export class ExtPropertiesItemsModel {
    name: string;
    value: string;
    constructor() {
    }
}
